import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=d49842dc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=d49842dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49842dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d49842dc')) {
      api.createRecord('d49842dc', component.options)
    } else {
      api.reload('d49842dc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=d49842dc&scoped=true&", function () {
      api.rerender('d49842dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hSE5pGf3mGQX/JS/comp/PopupBox.vue"
export default component.exports